<template>
  <moment :class-id='classId' :mon-types='monTypes' @back='goBack'></moment>
</template>

<script>
export default {
  name: "ClassMoment",
  props: {
    classId: [String, Number]
  },
  data() {
    const monTypes = [
      {
        text: "精彩瞬间",
        val: "wonder",
        ajaxParam: '',
      },
      {
        text: "我的瞬间",
        val: "my",
        ajaxParam:  "Individual",
      }
    ];
    return {
      monTypes,
    };
  },
  methods: {
    goBack() {
      /*this.$router.push({
        name: "TrainingClassDetail",
        params: { classId: this.classId }
      });*/
      this.$router.go(-1);
    }
  },
  components: {
    "moment": () => import('@/components/Moment/Moment'),
  },
};
</script>

<style lang="stylus">

</style>
